/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminGetOrganizerBalancesSummaryResponse { 
    /**
     * Total incoming earnings across all organizers (cents). Awaiting transfer to available for withdrawal.
     */
    totalIncomingEarnings: number;
    /**
     * Total funds available to withdraw across all organizers (cents).
     */
    totalAvailableToWithdraw: number;
    /**
     * Total pending payout across all organizers (cents). Awaiting reviewing.
     */
    totalPendingPayout: number;
}

